export default "__VITE_ASSET__DhTeQ0gj__"